import { initLoadable, type Loadable } from '@/loadingUtils'
import type { Study, Teach } from '@pocketprep/types'

type TExamSubjectWithLevels = {
    subjectName: string
    subjectId: string
    levels: number[]
}

interface IExamsModuleState {
    currentStudentExams: { [key: string]: Loadable<Teach.Class.OrgExamJSON[]> | undefined }
    currentStudentCurrentExamId: string | null
    currentOrgExams: { [orgId: string]: Loadable<{ [orgExamId: string]: Teach.Class.OrgExamJSON }> | undefined }
    examMetadata: Loadable<{ [objectId: string]: Study.Class.ExamMetadataJSON }>
    currentExamQuestions: Loadable<Study.Class.QuestionJSON[]>
    examSubjectsWithLevels: { [examMetadataId: string]: Loadable<TExamSubjectWithLevels[]> }
    currentExamMetadataIdByExamGuid: { [ examGuid: string ]: string }
    validateOrgExams: Loadable<null>
    mockExams: Loadable<Study.Class.MockExamJSON[]>
}

export const getInitialExamState = (): IExamsModuleState => {
    return {
        currentStudentExams: {},
        currentStudentCurrentExamId: null,
        currentOrgExams: {},
        examMetadata: initLoadable({}),
        currentExamQuestions: initLoadable([]),
        examSubjectsWithLevels: {},
        currentExamMetadataIdByExamGuid: {},
        validateOrgExams: initLoadable(null),
        mockExams: initLoadable([]),
    }
}

const moduleState = getInitialExamState()

export default moduleState
